module.exports = __webpack_public_path__ + "img/18223205000525.b9fec84d.png";